import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Invalid credentials");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <Link to="/" className="flex items-center justify-center gap-3 mb-8">
          <img src="/assets/beyond-borders-logo.png" alt="Shamima Yasmin Anwar" className="h-12 w-auto" />
        </Link>
        <div className="bg-white border border-slate-200 p-8 shadow-sm">
          <div className="flex items-center gap-3 mb-6">
            <Lock className="h-5 w-5 text-[#C43A89]" />
            <h1 className="font-display text-2xl text-[#29324A]">Admin Login</h1>
          </div>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label className="text-sm font-semibold text-[#29324A] mb-1.5 block">Email</Label>
              <Input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <Label className="text-sm font-semibold text-[#29324A] mb-1.5 block">Password</Label>
              <Input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <Button data-testid="admin-login-btn" type="submit" disabled={submitting} className="w-full bg-[#29324A] hover:bg-[#1f2638] text-white rounded-none py-5 font-semibold disabled:opacity-50">
              {submitting ? "Signing in..." : "Sign In"}
            </Button>
          </form>
          <div className="mt-5 text-center">
            <Link to="/" className="text-xs text-slate-500 hover:text-[#29324A]">← Back to site</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
